import HelpIconButton from "../Buttons/Iconbuttons/HelpIconButton";
import TextField from "@mui/material/TextField";
import { useId } from "react";

export default function NumberQuestion({
  min,
  max,
  fieldValue,
  questionText,
  modalTitle,
  modalDescription,
  onChange,
  modalOff = false,
}) {
  const fieldId = useId();

  return (
    <div className="mb-4 flex w-full items-start gap-2 text-[#666666]">
      <div>
        <p className="mb-2 text-[15px] font-semibold text-slate-700">{questionText}</p>
        <TextField
          size="small"
          sx={{ color: "#666666", maxWidth: 120 }}
          id={fieldId}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          InputProps={{
            inputProps: {
              min: min,
              max: max,
              "aria-label": questionText,
            },
          }}
          type="number"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={fieldValue}
        />
      </div>
      {!modalOff && (
        <HelpIconButton title={modalTitle} description={modalDescription} />
      )}
    </div>
  );
}
